import * as React from 'react';
import { useGroundingCommandBarOverflowMenu_unstable } from './useGroundingCommandBarOverflowMenu';
import { renderGroundingCommandBarOverflowMenu_unstable } from './renderGroundingCommandBarOverflowMenu';
import { useGroundingCommandBarOverflowMenuStyles_unstable } from './useGroundingCommandBarOverflowMenuStyles.styles';
import type { GroundingCommandBarOverflowMenuProps } from './GroundingCommandBarOverflowMenu.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// GroundingCommandBarOverflowMenu component - TODO: add more docs
export const GroundingCommandBarOverflowMenu: ForwardRefComponent<GroundingCommandBarOverflowMenuProps> =
  React.forwardRef((props, ref) => {
    const state = useGroundingCommandBarOverflowMenu_unstable(props, ref);

    useGroundingCommandBarOverflowMenuStyles_unstable(state);
    return renderGroundingCommandBarOverflowMenu_unstable(state);
  });

GroundingCommandBarOverflowMenu.displayName = 'GroundingCommandBarOverflowMenu';
